<template>
	<div class="upload-view h-full">
		<div
			class="input-container h-full bg-gray-400 rounded-lg border-dashed border-4 border-gray-600 p-4 flex items-center justify-center"
			:class="{ 'bg-gray-500': state == 'draggingOver' }"
			@drop.prevent="onDrop"
			@dragover.prevent
			@dragenter.prevent="state = 'draggingOver'"
			@dragleave.prevent="state = 'draggingOver'"
		>
			<input type="file" name="file-input" id="file" class="sr-only" @change="onFileInputChange" />
			<label
				for="file"
				class="flex flex-col items-center text-xl border-2 border-solid border-gray-600 rounded-md p-4 bg-gray-500 hover:bg-gray-600 text-gray-200 cursor-pointer transition-colors duration-200 ease-out"
				v-if="['waiting', 'error'].includes(state)"
			>
				<font-awesome-icon icon="file-upload" size="4x" />
				<span class="mt-2 text-center">Upload a Git Diff/Commit<br />or CodeReview export</span>
			</label>
			<font-awesome-icon v-else-if="state == 'processing'" icon="spinner" size="4x" class="text-gray-200"></font-awesome-icon>
		</div>
	</div>
</template>

<script>
export default {
	name: 'UploadView',
	data() {
		return {
			state: 'waiting',
		};
	},
	methods: {
		onDrop(e) {
			if (this.state === 'processing') return;
			this.state = 'processing';

			if (e.dataTransfer.items) {
				// Use DataTransferItemList interface to access the file(s)
				for (let i = 0; i < e.dataTransfer.items.length; i++) {
					// If dropped items aren't files, reject them
					if (e.dataTransfer.items[i].kind === 'file') {
						const file = e.dataTransfer.items[i].getAsFile();
						return this.fileChosen(file);
					}
				}
			} else {
				// Use DataTransfer interface to access the file(s)
				for (let i = 0; i < e.dataTransfer.files.length; i++) {
					return this.fileChosen(e.dataTransfer.files[i]);
				}
			}

			this.state = 'waiting';
		},
		onFileInputChange(e) {
			if (this.state === 'processing') return;
			this.state = 'processing';
			return this.fileChosen(e.target.files[0]);
		},
		fileChosen: async function(file) {
			try {
				const text = await this.readFile(file);
				if (file.type === 'application/json') {
					const import_data = JSON.parse(text);
					this.$store.dispatch('fileChosen', { file, textContent: import_data.fileContent });
					this.$store.commit('setComments', import_data.comments);
				} else {
					this.$store.dispatch('fileChosen', { file, textContent: text });
				}
				this.state = 'success';
			} catch (err) {
				this.state = 'error';
			}
		},
		readFile(file) {
			return new Promise((resolve, reject) => {
				if (file) {
					var reader = new FileReader();

					reader.onload = function(evt) {
						resolve(evt.target.result);
					};

					reader.onerror = function(evt) {
						reject(evt);
					};

					reader.readAsText(file, 'UTF-8');
				} else {
					reject();
				}
			});
		},
	},
};
</script>
